import { ChakraFlex as Flex } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import type { CompensationFeeCardsProps } from "./CompensationFeeCards.d";
import { CompensationFeeCard } from "./CompensationFeeCard/CompensationFeeCard";

const CompensationFeeCards = ({ cards, sbEditable }: SbEditableComponentProps<CompensationFeeCardsProps>) => (
  <Flex
    width="full"
    direction={{ base: "column", lg: "row" }}
    border="1px"
    borderColor="greyscale.400"
    borderRadius="lg"
    overflow="hidden"
    {...sbEditable}
  >
    {cards.map(({ ...card }) => (
      <CompensationFeeCard key={card._uid} {...card} />
    ))}
  </Flex>
);

export default CompensationFeeCards;
